<script setup="">
import { onMounted, ref } from "vue";

import { Color } from "@tiptap/extension-color";
import { Link } from "@tiptap/extension-link";
import { Table } from "@tiptap/extension-table";
import { TableCell } from "@tiptap/extension-table-cell";
import { TableHeader } from "@tiptap/extension-table-header";
import { TableRow } from "@tiptap/extension-table-row";
import { TextAlign } from "@tiptap/extension-text-align";
import { TextStyle } from "@tiptap/extension-text-style";
import { StarterKit } from "@tiptap/starter-kit";
import { Editor, EditorContent } from "@tiptap/vue-3";

const props = defineProps({
  campaign: {
    type: Object,
    required: true
  },
  pageMeta: {
    type: Object,
    required: true
  }
});

const tiptap = ref(null);

onMounted(() => {
  tiptap.value = new Editor({
    extensions: [
      StarterKit,
      TextAlign.configure({
        types: ["heading", "paragraph"]
      }),
      TextStyle,
      Link,
      Table.configure({
        resizable: true
      }),
      TableHeader,
      TableRow,
      TableCell,
      Color
    ],
    content: JSON.parse(props.pageMeta.content),
    editable: false
  });
});
</script>

<template>
  <div class="px-4 py-8">
    <editor-content :editor="tiptap" class="min-h-[600px] dark:border-zinc-700" />
  </div>
</template>
